// extracted by mini-css-extract-plugin
module.exports = {"main_white":"#ffffff","header":"styles_header__t9Fpo"};